(function () {
  'use strict';

  var app = document.getElementById('gt-myforms-app');
  if (!app) return;

  var NETLIFY     = app.dataset.netlify;
  var CUSTOMER_ID = app.dataset.customerId;

  var loadingEl = app.querySelector('.gt-myforms__loading');
  var emptyEl   = app.querySelector('.gt-myforms__empty');
  var listEl    = app.querySelector('.gt-myforms__list');

  function init() {
    if (!CUSTOMER_ID) {
      loadingEl.hidden = true;
      emptyEl.hidden = false;
      emptyEl.textContent = 'Please log in to view your forms.';
      return;
    }

    fetch(NETLIFY + '/get-customer-forms?customer_id=' + CUSTOMER_ID)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        loadingEl.hidden = true;
        if (!data.forms || !data.forms.length) {
          emptyEl.hidden = false;
          return;
        }
        listEl.hidden = false;
        data.forms.forEach(function (form) {
          listEl.appendChild(buildCard(form));
        });
      })
      .catch(function () {
        loadingEl.hidden = true;
        emptyEl.hidden = false;
        emptyEl.textContent = 'Error loading forms. Try refreshing.';
      });
  }

  function buildCard(form) {
    var isActive  = form.status === 'active';
    var shareUrl  = window.location.origin + '/pages/bulk-order?id=' + form.form_id;
    var deadlineStr = '';
    if (form.deadline) {
      var d = new Date(form.deadline);
      deadlineStr = '<span class="gt-myforms__deadline">Due ' +
        d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) +
        '</span>';
    }

    var card = document.createElement('div');
    card.className = 'gt-myforms__card' + (isActive ? '' : ' gt-myforms__card--closed');
    card.dataset.formId = form.form_id;

    card.innerHTML =
      '<div class="gt-myforms__card-header">' +
        '<div class="gt-myforms__card-info">' +
          '<h3 class="gt-myforms__card-name">' + esc(form.form_name) + '</h3>' +
          '<p class="gt-myforms__card-product">' + esc(form.product_title || form.product_handle) + '</p>' +
        '</div>' +
        '<div class="gt-myforms__card-meta">' +
          '<span class="gt-myforms__badge gt-myforms__badge--' + (isActive ? 'active' : 'closed') + '">' +
            (isActive ? 'Active' : 'Closed') +
          '</span>' +
          '<span class="gt-myforms__sub-count"><strong>' + form.submission_count + '</strong> submission' + (form.submission_count !== 1 ? 's' : '') + '</span>' +
          deadlineStr +
        '</div>' +
      '</div>' +
      '<div class="gt-myforms__card-actions">' +
        '<button class="gt-myforms__btn gt-myforms__btn--secondary js-view-subs" data-form-id="' + form.form_id + '">View Submissions</button>' +
        '<button class="gt-myforms__btn gt-myforms__btn--primary js-add-cart" data-form-id="' + form.form_id + '"' + (!form.submission_count ? ' disabled' : '') + '>Add All to Cart</button>' +
        '<button class="gt-myforms__btn gt-myforms__btn--checkout js-add-checkout" data-form-id="' + form.form_id + '"' + (!form.submission_count ? ' disabled' : '') + '>Add All &rarr; Checkout</button>' +
        (isActive ? '<button class="gt-myforms__btn gt-myforms__btn--danger js-close-form" data-form-id="' + form.form_id + '">Close Form</button>' : '') +
        '<button class="gt-myforms__btn gt-myforms__btn--ghost js-copy-link" data-url="' + esc(shareUrl) + '">Copy Link</button>' +
        '<button class="gt-myforms__btn gt-myforms__btn--danger js-delete-form" data-form-id="' + form.form_id + '">Delete</button>' +
      '</div>' +
      '<div class="gt-myforms__subs-table" id="subs-' + form.form_id + '" hidden>' +
        '<div class="gt-myforms__subs-loading">Loading submissions...</div>' +
      '</div>';

    return card;
  }

  // ── Event delegation ─────────────────────────────────────────────────
  app.addEventListener('click', function (e) {
    var btn = e.target.closest('button');
    if (!btn) return;

    var formId = btn.dataset.formId;

    if (btn.classList.contains('js-view-subs')) {
      var table = document.getElementById('subs-' + formId);
      if (table.hidden) {
        table.hidden = false;
        btn.textContent = 'Hide Submissions';
        loadSubmissions(formId, table);
      } else {
        table.hidden = true;
        btn.textContent = 'View Submissions';
      }
    }

    if (btn.classList.contains('js-close-form')) {
      if (!confirm('Close this form? Members won\'t be able to submit new orders.')) return;
      btn.disabled = true;
      btn.textContent = 'Closing...';
      fetch(NETLIFY + '/close-bulk-form', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ form_id: formId, customer_id: CUSTOMER_ID }),
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data.success) {
            var card = btn.closest('.gt-myforms__card');
            card.classList.add('gt-myforms__card--closed');
            var badge = card.querySelector('.gt-myforms__badge');
            badge.className = 'gt-myforms__badge gt-myforms__badge--closed';
            badge.textContent = 'Closed';
            btn.remove();
          } else {
            btn.disabled = false;
            btn.textContent = 'Close Form';
            alert('Error: ' + (data.error || 'Could not close form.'));
          }
        })
        .catch(function () {
          btn.disabled = false;
          btn.textContent = 'Close Form';
          alert('Error closing form. Please try again.');
        });
    }

    if (btn.classList.contains('js-add-cart') || btn.classList.contains('js-add-checkout')) {
      var toCheckout = btn.classList.contains('js-add-checkout');
      btn.disabled = true;
      btn.textContent = 'Loading...';

      fetch(NETLIFY + '/get-submissions?id=' + formId)
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (!data.submissions || !data.submissions.length) {
            btn.disabled = false;
            btn.textContent = toCheckout ? 'Add All \u2192 Checkout' : 'Add All to Cart';
            alert('No submissions found.');
            return;
          }

          var items = data.submissions
            .filter(function (s) { return s.variant_id; })
            .map(function (s) {
              var item = { id: s.variant_id, quantity: s.quantity || 1 };
              if (s.properties && s.properties.length) {
                item.properties = {};
                s.properties.forEach(function (p) {
                  if (!p.name.startsWith('_')) item.properties[p.name] = p.value;
                });
              }
              item.properties = item.properties || {};
              item.properties['_Submitted by'] = s.member_name || 'Member';
              return item;
            });

          if (!items.length) {
            btn.disabled = false;
            btn.textContent = toCheckout ? 'Add All \u2192 Checkout' : 'Add All to Cart';
            alert('No items with valid variants to add.');
            return;
          }

          btn.textContent = 'Adding to cart...';
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: items }),
          })
            .then(function (r) { if (!r.ok) throw new Error(); return r.json(); })
            .then(function () {
              // Tag the cart so the order webhook knows which form to delete
              return fetch('/cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ attributes: { gt_bulk_form_id: formId } }),
              });
            })
            .then(function () {
              window.location.href = toCheckout ? '/checkout' : '/cart';
            })
            .catch(function () {
              btn.disabled = false;
              btn.textContent = toCheckout ? 'Add All \u2192 Checkout' : 'Add All to Cart';
              alert('Error adding to cart. Please try again.');
            });
        })
        .catch(function () {
          btn.disabled = false;
          btn.textContent = toCheckout ? 'Add All \u2192 Checkout' : 'Add All to Cart';
          alert('Error loading submissions.');
        });
    }

    if (btn.classList.contains('js-delete-form')) {
      if (!confirm('Permanently delete this form and all submissions? This cannot be undone.')) return;
      deleteForm(formId, btn.closest('.gt-myforms__card'));
    }

    if (btn.classList.contains('js-copy-link')) {
      var url = btn.dataset.url;
      var orig = btn.textContent;
      navigator.clipboard.writeText(url)
        .then(function () {
          btn.textContent = 'Copied!';
          setTimeout(function () { btn.textContent = orig; }, 2200);
        })
        .catch(function () {
          // Fallback
          var el = document.createElement('textarea');
          el.value = url;
          el.style.position = 'fixed';
          el.style.opacity = '0';
          document.body.appendChild(el);
          el.select();
          document.execCommand('copy');
          document.body.removeChild(el);
          btn.textContent = 'Copied!';
          setTimeout(function () { btn.textContent = orig; }, 2200);
        });
    }
  });

  function deleteForm(formId, cardEl) {
    fetch(NETLIFY + '/delete-bulk-form', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ form_id: formId, customer_id: CUSTOMER_ID }),
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.success && cardEl) {
          cardEl.style.transition = 'opacity 0.3s ease, transform 0.3s ease';
          cardEl.style.opacity = '0';
          cardEl.style.transform = 'translateY(-4px)';
          setTimeout(function () {
            cardEl.remove();
            if (!listEl.querySelector('.gt-myforms__card')) {
              listEl.hidden = true;
              emptyEl.hidden = false;
            }
          }, 300);
        }
      })
      .catch(function () { alert('Error deleting form. Please try again.'); });
  }

  function loadSubmissions(formId, container) {
    fetch(NETLIFY + '/get-submissions?id=' + formId)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (!data.submissions || !data.submissions.length) {
          container.innerHTML = '<p class="gt-myforms__subs-empty">No submissions yet.</p>';
          return;
        }

        var rows = data.submissions.map(function (s, i) {
          var opts = (s.properties || [])
            .filter(function (p) { return !p.name.startsWith('_'); })
            .map(function (p) { return esc(p.name) + ': ' + esc(p.value); })
            .join(', ');
          var date = new Date(s.submitted_at).toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
          return '<tr>' +
            '<td>' + (i + 1) + '</td>' +
            '<td>' + esc(s.member_name || 'Anonymous') + '</td>' +
            '<td>' + (opts || '—') + '</td>' +
            '<td>' + (s.quantity || 1) + '</td>' +
            '<td>' + date + '</td>' +
            '</tr>';
        }).join('');

        container.innerHTML =
          '<table class="gt-myforms__table">' +
            '<thead><tr><th>#</th><th>Name</th><th>Options</th><th>Qty</th><th>Date</th></tr></thead>' +
            '<tbody>' + rows + '</tbody>' +
          '</table>';
      })
      .catch(function () {
        container.innerHTML = '<p class="gt-myforms__subs-empty">Error loading submissions.</p>';
      });
  }

  function esc(str) {
    if (!str) return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  init();
})();
